var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "logo" },
    [
      _c(
        "div",
        {
          staticClass: "logo__hamburger",
          class: { "logo__hamburger--open": _vm.navMenuOpen },
          on: { click: _vm.toggleMenu }
        },
        [
          _c("div", { staticClass: "logo__hamburger-line" }),
          _c("div", { staticClass: "logo__hamburger-line" }),
          _c("div", { staticClass: "logo__hamburger-line" })
        ]
      ),
      _c("router-link", { attrs: { to: { name: "home" } } }, [
        _vm.cobrandLogo
          ? _c("img", {
              key: "cobrand-logo",
              staticClass: "logo__image",
              attrs: { src: _vm.cobrandLogo }
            })
          : _c(
              "svg",
              {
                key: "app-logo",
                staticClass: "logo__image",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 94.349997 86.700001",
                  version: "1.1",
                  width: "94.349998",
                  height: "86.699997"
                }
              },
              [
                _c("path", {
                  staticClass: "logo__right",
                  attrs: {
                    d:
                      "m 24.712404,40.37347 15.56928,14.688 c 0.4896,0.4896 0.78336,1.37088 1.07712,2.05632 1.9584,5.8752 4.01472,11.7504 5.58144,16.45056 4.896,-17.03808 10.08576,-35.05536 15.27552,-53.3664 5.3856,1.9584 10.57536,3.81888 16.05888,5.67936 1.9584,-4.896 3.81888,-9.596159 5.77728,-14.590077 l -14.1984,-7.7356762 23.79456,7.1481572 c -3.62304,8.323196 -7.14816,16.548476 -10.86912,24.871676 -6.3546,-1.7136 -6.3546,-1.7136 -11.45664,-3.13344 -5.975074,17.73964 -12.116483,36.48422 -17.136,51.8976 -0.4896,1.468797 -1.17504,1.860477 -2.64384,1.860477 -3.23136,-0.0979 -6.46272,0 -9.59616,-0.0979 -0.58752,0 -1.478606,-0.17392 -1.76256,-0.979197 C 34.016777,67.63374 28.398118,51.12113 24.712404,40.37347 Z"
                  }
                }),
                _c("path", {
                  staticClass: "logo__left",
                  attrs: {
                    d:
                      "m 39.664187,48.5879 c -5.216047,-4.76286 -10.8566,-9.88477 -15.386,-14.112 -0.98,-0.882 -1.764,-1.078 -2.94,-0.686 -3.234,0.98 -6.37,1.862 -9.898,2.744 C 7.9121875,28.3999 4.3841875,20.3639 0.66018746,12.131903 8.6437511,8.4521464 17.38625,4.6609067 24.474187,1.645907 c 1.47,-0.588 3.136,-0.88200012 4.704,-0.98000012 3.234,-0.196 6.468,0 9.8,0 0.784,4.99799972 2.548,9.40799712 8.428,9.79999712 4.116,0.294 7.35,-2.5479976 9.31,-7.6439971 1.078,5.1939995 -2.548,10.8779951 -7.644,12.7399941 -6.664,2.449999 -13.328,0.196 -16.17,-5.6839966 -2.94,-0.2939985 -5.684,0 -8.33,1.3719986 -3.92,1.959999 -8.134,3.625998 -12.25,5.487998 1.078,2.841999 2.156,5.585999 3.332,8.231999 0.196,0.392 1.274,0.784 1.764,0.686 4.214,-1.078 8.526,-2.254 12.74,-3.528 1.47,-0.392 2.058,-0.294 2.45,1.274 3.332,12.446 3.332,12.446 7.056,25.186 z"
                  }
                })
              ]
            )
      ]),
      _c("help-logo", {
        attrs: { "for-mobile": "for-mobile" },
        on: { click: _vm.handleHelpClick }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }